module.exports = __webpack_public_path__ + "img/roadmap.5b3b5c45.png";